import { render, staticRenderFns } from "./ChevronDown.vue?vue&type=template&id=55674acc&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../Sites/dsgnwrks.pro/wp-content/plugins/optinmonster/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports